console.log('%c\\\\\\>>> 歡迎光臨OURS森林好朋友🐻🐻🐻 <<<///','font-size: 30px; color: #ea5506; background: #f7c114');
$('#to_top').on('click', function () {
  $('html, body').animate({scrollTop: 0}, {duration: 800, queue: false, easing: 'easeInOutExpo'});
});
function get_csrf_token() {
  return $('#csrf-token').attr('content');
}